import React, { useState } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { Icon, SearchBar, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import RestrictedView from 'shared/RestrictedView';
import { useSelector } from 'react-redux';

const ImportToolbar = () => {
    const [params] = useSearchParams();

    const isReadingRecordsLimits = useSelector(state => state.contact.isReadingRecordsLimits);

    const navigate = useNavigate();

    const searchQuery = params.get('search') || '';
    const [search, setSearch] = useState(searchQuery);

    const onSearchSubmit = () => {
        const query = new URLSearchParams(params);
        query.set('search', search.trim());
        query.set('page', 1);
        const query_string = query.toString();
        navigate(`/settings/import-data${query_string ? `?${query_string}` : ''}`);
    }

    const cancelFunction = () => {
        const query = new URLSearchParams(params);
        query.delete('search');
        const query_string = query.toString();
        navigate(`/settings/import-data${query_string ? `?${query_string}` : ''}`);
    }

    const onChangeSearch = (_, { value }) => {
        setSearch(value);
    }

    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <div className='ImportToolbar'>
                        <SearchBar
                            search={searchQuery}
                            searchFcn={onSearchSubmit}
                            cancelFcn={cancelFunction}
                            placeholder={'Search by file name or file description'}
                            onChange={onChangeSearch}
                            bottomError
                        />
                        <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.IMPORT_DATA_ADD} productPermission={PRODUCT_PERMISSIONS.RECORDS}>
                        <Button as={Link} to="/settings/import-data/setup" color='primary' className='AddImportButton' disabled={isReadingRecordsLimits} content={
                            <span><Icon name='plus' /> New Import</span>
                        } />
                        </RestrictedView>
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default ImportToolbar;
